// Fecha: 11-07-2024


import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewCargaStockDiario = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'carga_stock_diario',
        name: 'Carga Stock Diario',
        component: ViewCargaStockDiario,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
